module.exports = __webpack_public_path__ + "static/media/icn-med-professionals.acb1f0d3.svg";